import { RType } from '@batical/types/src'

export function fetchGenericSorted<T extends RType>(data: Array<T>): Array<{ value: string; label: string }> {
  return sortDataSorted(data).map((child: RType) => {
    return { value: child.uuid, label: child.name }
  })
}

export function fetchGeneric<T extends RType>(data: Array<T>, uuid: string): T {
  let result = data.filter((item: RType) => item.uuid === uuid)
  if (result && result.length > 0) {
    return result[0]
  }
  return data.sort((a: RType, b: RType) => a.uuid.localeCompare(b.uuid))[0]
}

export function sortDataSorted<T extends RType>(data: Array<T>) {
  return data.sort((a: RType, b: RType) => a.name.localeCompare(b.name))
}
